"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationSubscriptionsSchemaProperties = exports.IntegrationSubscriptionsSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const integration_1 = require("./integration");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.IntegrationSubscriptionsSchema = base_schema_1.BaseSchema.extend({
    expiresOn: zod_1.z.date(),
    integrationId: zod_1.z.string(),
    aid: zod_1.z.string(),
    uid: zod_1.z.string(),
    resourceId: zod_1.z.string().optional().nullable(),
    resourceKey: zod_1.z.string(),
    status: zod_1.z.enum(["active", "failed"]).optional(),
    provider: integration_1.ProviderSchema,
    resourceType: zod_1.z.enum(["calendars", "events"]),
    subscriptionData: zod_1.z.any().optional(),
});
exports.IntegrationSubscriptionsSchemaProperties = {
    collectionName: "integrationSubscriptions",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=integration-subscriptions.js.map